import type { DocumentNode } from 'graphql'
import { gql } from 'graphql-tag'

const postValidatePasswordResetCode: DocumentNode = gql`
  mutation PostValidatePasswordResetCode($code: String!) {
    postValidatePasswordResetCode(input: { code: $code }) {
      valid
      reason
    }
  }
`

export default postValidatePasswordResetCode
